var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 45,
    viewBox: "0 0 67 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.0188 16.9875C52.1204 7.28438 43.6617 0 33.5 0C25.4321 0 18.425 4.6125 14.9354 11.3625C6.5325 12.2625 0 19.4344 0 28.125C0 32.6005 1.76473 36.8928 4.90596 40.0574C8.0472 43.2221 12.3076 45 16.75 45H53.0417C54.8747 45 56.6898 44.6363 58.3833 43.9296C60.0768 43.2229 61.6155 42.187 62.9117 40.8812C64.2078 39.5754 65.236 38.0251 65.9375 36.319C66.639 34.6128 67 32.7842 67 30.9375C67 23.5125 61.2771 17.4937 54.0188 16.9875ZM53.0417 39.375H16.75C13.7884 39.375 10.9481 38.1897 8.85397 36.0799C6.75982 33.9702 5.58333 31.1087 5.58333 28.125C5.58333 22.3594 9.85458 17.55 15.5217 16.9594L18.5088 16.65L19.9046 13.9781C22.5567 8.83125 27.7492 5.625 33.5 5.625C40.8142 5.625 47.1233 10.8563 48.5471 18.0844L49.3846 22.3031L53.6558 22.6125C58.0108 22.8937 61.4167 26.5781 61.4167 30.9375C61.4167 33.1753 60.5343 35.3214 58.9637 36.9037C57.3931 38.4861 55.2629 39.375 53.0417 39.375ZM22.3333 25.3125H29.4521V33.75H37.5479V25.3125H44.6667L33.5 14.0625L22.3333 25.3125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUploadIcon);
export default __webpack_public_path__ + "static/media/cloud-upload-icon.53e784fc.svg";
export { ForwardRef as ReactComponent };